import { Components } from "@thisgorilla/primate-ds";
import { useEffect, useRef } from "react";
import styled, { useTheme } from "styled-components";
import { TextGroup } from "../../../../../commonStyles";
import {
  FlexColumn,
  FlexColumnCenter,
  FlexRowCenter,
} from "../../../../Common/Styles";
import { FollowersFollowingProps } from "./FollowersFollowing";

export const RemoveFollower = (
  props: FollowersFollowingProps.RemoveFollower
) => {
  const cancelRef = useRef<HTMLButtonElement>(null);
  const { user, onCancelClick, onConfirmClick } = props;
  const { typography } = useTheme();

  useEffect(() => {
    if (!cancelRef.current) return;
    cancelRef.current.focus();
  }, [props.showModal]);
  const handleClose = () => {
    onCancelClick();
    const followingModal = document.getElementById("following-modal");
    if (followingModal) {
      const searchInput = followingModal.querySelector('input[type="search"]');
      if (searchInput) {
        (searchInput as HTMLElement).focus();
      }
    }
  };

  if (!user) return <></>;
  const name = `${user.first_name} ${user.last_name}`.trimEnd();
  return (
    <Container>
      <FlexColumnCenter $gapInPx={8}>
        <Components.Avatar
          size="XLarge-72"
          src={user.profile_picture}
          type="Circle"
        />
        <Components.Text
          style={{ tokenStyle: typography.Body.M }}
          letterSpacing="letter-spacing-100"
          text={`Remove follower?`}
          fontWeight="font-weight-semibold"
        />
        <TextGroup>
          <Components.Text
            style={{ tokenStyle: typography.Body.M }}
            letterSpacing="letter-spacing-100"
            text={`ThisGorilla won't tell`}
          />
          <Components.Text
            style={{ tokenStyle: typography.Body.M }}
            letterSpacing="letter-spacing-100"
            text={` ${name} `}
            fontWeight="font-weight-semibold"
          />
          <Components.Text
            style={{ tokenStyle: typography.Body.M }}
            letterSpacing="letter-spacing-100"
            text={`they were removed from yout followers.`}
          />
        </TextGroup>
      </FlexColumnCenter>
      <Underline />
      <Buttons $gapInPx={8}>
        <Components.Button
          kind="Tertiary"
          size="Small"
          color="Negative"
          disabled={false}
          label="Remove"
          onClick={() => {
            onConfirmClick(user.id);
            // Focus back on the following modal after unfollow
            setTimeout(() => {
              const followingModal = document.getElementById("following-modal");
              if (followingModal) {
                const searchInput = followingModal.querySelector(
                  'input[type="search"]'
                );
                if (searchInput) {
                  (searchInput as HTMLElement).focus();
                }
              }
            }, 100);
          }}
          tabIndex={2}
        />
        <Components.Button
          kind="Tertiary"
          size="Small"
          color="Primary"
          disabled={false}
          label="Cancel"
          onClick={handleClose}
          buttonRef={cancelRef}
          tabIndex={1}
        />
      </Buttons>
    </Container>
  );
};

const Container = styled(FlexColumn)`
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
`;
const Underline = styled.div`
  border: ${({ theme }) => theme.border_width["border-width-thin"].value}rem
    solid ${({ theme }) => theme.Color.border["ui-border-neutral"].value};
`;
const Buttons = styled(FlexRowCenter)``;
